import React, { useEffect, useState } from 'react'
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { useNavigate } from 'react-router-dom';

const waitingTime = 5;
let timerSeconds = waitingTime;
const Autoplay = ({ episodes, setIsAutoplayView, isPlaylist = false, onVideoChange, currentVideoId, season, template, thumbnailOrientation }) => {
    const [timer, setTimer] = useState(waitingTime)
    const navigate = useNavigate()

    let episodesList = episodes;
    if (isPlaylist && Array.isArray(episodes) && episodes.length > 0 && episodes[0]?.season && episodes[0]?.videos) {
        episodesList = episodes.reduce((acc, seasonObj) => acc.concat(seasonObj.videos || []), []);
    }

    useEffect(() => {
        if (isPlaylist && episodesList) {
            playNextEpisodeHandler();
            return;
        }
        const interval = setInterval(() => {
            timerSeconds--
            if (timerSeconds >= 0) {
                setTimer((prev) => prev - 1)
            } else {
                clearInterval(interval)
            }

        }, 1000);

        return () => {
            clearInterval(interval)
            resetValues()
        }
    }, [])

    useEffect(() => {
        if (timer === 0) {
            playNextEpisodeHandler()
        }
    }, [timer])

    const playNextEpisodeHandler = () => {
        setIsAutoplayView(false)
        setTimer(waitingTime)
        timerSeconds = waitingTime
        if (isPlaylist && episodesList) {
            const currentIndex = episodesList.findIndex(
                (episode) => episode.video_id === currentVideoId
            );

            const nextIndex = currentIndex + 1;
            if (episodesList[nextIndex]) {
                onVideoChange(episodesList[nextIndex]);
            }
        } else if (episodesList && episodesList[0]) {
            navigate(`/videos/${episodesList[0]?.vanity_url}`, { state: { videoDetails: { video_id: episodesList[0]?.video_id } } })
        }
    }

    const resetValues = () => {
        setTimer(waitingTime)
        timerSeconds = waitingTime

    }

    return (
        <div className='autoplayComponent'>
            <div className="content" style={{
                backgroundImage: episodesList && episodesList[0]?.thumbnail_350_200
                    ? `url(${episodesList[0].thumbnail_350_200})`
                    : 'none',
            }} onClick={() => { playNextEpisodeHandler() }}>

                <div className="progressBar">
                    <CircularProgressbar
                        value={Math.round((waitingTime - timer) * waitingTime)}
                        text={`${timer}s`}
                        styles={buildStyles({
                            pathColor: `var(--button-color)`,
                            textColor: `var(--button-color)`,
                        })}
                    />
                </div>
                <div><h1 className="heading">{episodesList[0]?.video_title}</h1></div>

            </div>
        </div>
    )
}

export default Autoplay
